import { FC } from "react";
import Sprite from "./Sprite";
import "./GameOver.css";

export interface GameOverProps {
  onRestart: () => void;
  finalMoney: number;
  turnsPlayed?: number;
}

const GameOver: FC<GameOverProps> = ({
  onRestart,
  finalMoney,
  turnsPlayed = 0,
}) => {
  return (
    <div className="game-over-overlay">
      <div className="game-over-backdrop" />
      <div className="game-over-container">
        <div className="game-over-header">
          <h1>Out Of Cash!</h1>
        </div>

        <div className="game-over-content">
          <div className="game-over-message">
            You ran out of cards and don't have enough money to buy more!
          </div>

          <div className="game-over-stats">
            <h3>Final Stats</h3>
            <div className="stat-row">
              <span className="flex items-center gap-1">
                <Sprite
                  filename="/images/resources_20.png"
                  x={5}
                  y={0}
                  width={20}
                  height={20}
                  className="inline-block"
                />
                Money:
              </span>
              <span>${finalMoney}</span>
            </div>
            {turnsPlayed > 0 && (
              <div className="stat-row">
                <span>Turns Survived:</span>
                <span>{turnsPlayed}</span>
              </div>
            )}
          </div>

          <button className="game-over-raid-btn" onClick={onRestart}>
            💀 Raid Neighbors! 💀
          </button>

          <button className="game-over-restart-btn" onClick={onRestart}>
            Restart Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameOver;
